import React, { useState } from 'react'

import clsx from 'clsx'

import { CardActionArea } from 'components/Card'
import Icon from 'components/Icon'
import Lightbox from 'components/Lightbox'
import { FixedImage } from 'components/NextImage'
import { EventContext, useEventContext } from 'context/EventContext'

import NO_VIDEOS from './constants'

import classes from './ListingVideos.module.scss'

/** @type {import("./types").default} */
const ListingVideos = ({ listing = {} }) => {
  const [lightboxState, setLightboxState] = useState({ loaded: false, toggler: false })
  const { addEvent, sendEvent } = useEventContext({
    engagementComponent: 'product_media',
  })
  const { name, videos = [] } = listing

  const handleOnClose = () => {
    sendEvent({
      engagementComponent: 'product_media',
      engagementDestination: 'close-media',
      engagementDetails: 'media',
      name: 'engagement_product_click',
    })
  }

  const lightboxToggleHandler = () => {
    setLightboxState({
      loaded: true,
      toggler: !lightboxState.toggler,
    })
  }

  return (
    <>
      {videos && videos.length > 0 ? (
        <>
          <CardActionArea
            className={clsx(classes.videoContainer, classes.videoFocus)}
            role="link"
            tabIndex="0"
            onClick={lightboxToggleHandler}
            onKeyPress={lightboxToggleHandler}
            {...addEvent({
              engagementDestination: 'open-media',
              engagementDetails: 'media',
              name: 'engagement_product_click',
            })}
          >
            <FixedImage
              className={classes.videoImage}
              fetchWidth={310}
              width={310}
              height={208}
              title={name}
              alt={name}
              src={videos[0].thumbnail}
            />
            <div className={classes.videoCaption}>
              <Icon icon={['far', 'play']} className={classes.playIcon} />
              {videos.length} video{videos.length > 1 ? 's' : ''}
            </div>
          </CardActionArea>
          {lightboxState.loaded && (
            <EventContext value={{ engagementComponent: 'product_media' }}>
              <Lightbox
                onClose={handleOnClose}
                openOnMount
                sources={videos.map(({ embed_url, url }) => embed_url || url)}
                toggler={lightboxState.toggler}
              />
            </EventContext>
          )}
        </>
      ) : (
        <div className={classes.emptyvideoContainer}>
          <Icon icon={['far', 'film']} className={classes.imagesIcon} />
          <div className={classes.emptyvideoText}>{NO_VIDEOS}</div>
        </div>
      )}
    </>
  )
}

export default ListingVideos
